import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useState } from 'react';
import { RunStatus, setActiveRun, Run } from '../../../store/Run';
import { TextBlock } from '../../Atoms/Text';
import { DEFAULT_ADVANCE_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON_STYLE } from '../../../utils/styleHelpers';
import { ComponentSpinner } from '../../Compounds/Loading/ComponentSpinner';
import { RunSelection } from '../../Compounds/Run/RunSelection';

export const SetActiveRunDialog = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedRun, setSelectedRun] = useState<Run | null>(null);

  const handleSave = async () => {
    if (!selectedRun) return;
    setIsSubmitting(true);
    await setActiveRun(selectedRun.id);
    setIsSubmitting(false);
    onClose();
  };

  return (
    <Dialog
      fullWidth
      onClose={onClose}
      open={open}
      maxWidth="xs">
      <DialogTitle>
        <TextBlock
          color="grey9"
          weight="bold"
          size="lg">
          Set Active Run
        </TextBlock>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4, pb: 2 }}>
        <RunSelection
          selectedRunId={selectedRun?.id || null}
          setSelectedRun={setSelectedRun}
          types={[RunStatus.PROCESSING, RunStatus.PENDING_LOCK, RunStatus.LOCKED]}
          withLabel={false}
        />
      </DialogContent>
      <hr className="mb-1 mx-6" />
      <DialogActions sx={{ marginRight: 2, pb: 2 }}>
        <button
          className={DEFAULT_CANCEL_BUTTON_STYLE}
          onClick={onClose}>
          Cancel
        </button>
        {isSubmitting ? (
          <div className="flex">
            <ComponentSpinner
              sx={{ mt: '0', m: '0' }}
              label="Saving..."
            />
          </div>
        ) : (
          <button
            data-testid="submit-confirmation"
            disabled={!selectedRun}
            onClick={handleSave}
            className={DEFAULT_ADVANCE_BUTTON_STYLE}
            type="submit">
            Save
          </button>
        )}
      </DialogActions>
    </Dialog>
  );
};
